// extracted by mini-css-extract-plugin
export var columnContainer = "styles-module--columnContainer--34200";
export var columnTitle = "styles-module--columnTitle--298d6";